'use client';

import { c as _c } from "react/compiler-runtime";
import { useUserIdentity } from '@shared/utils/context/UserContext';
import useLocalPreference from '@shared/utils/hooks/useLocalPreference';
import usePreference from '@shared/utils/hooks/usePreference';
import { Logo } from '@shared/utils/icons';
import usePresence from '../../../../hooks/usePresence';
import { client } from '../../../../utils/trpc';
import { useAuthModals } from '../../../../widgets/WidgetsContext';
type Props = {
  factiiiFilterOpen: boolean;
  setFactiiiFilterOpen: (open: boolean) => void;
};
const FactiiiFilterButton: React.FC<Props> = t0 => {
  const $ = _c(32);
  const {
    factiiiFilterOpen,
    setFactiiiFilterOpen
  } = t0;
  const currentUser = useUserIdentity();
  const {
    openAuthContinueModal
  } = useAuthModals();
  const {
    localPreferenceState
  } = useLocalPreference();
  const {
    preferenceState
  } = usePreference(client);
  const t1 = localPreferenceState.dataFilter.length > 0;
  const t2 = localPreferenceState.selectedFactiiis.length > 0;
  const t3 = localPreferenceState.displayMode !== "posts";
  let t4;
  if ($[0] !== localPreferenceState.filterBot || $[1] !== localPreferenceState.filterNew || $[2] !== localPreferenceState.showBoards || $[3] !== preferenceState.allowNSFWContent || $[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = [localPreferenceState.filterBot, localPreferenceState.filterNew, localPreferenceState.showBoards, preferenceState.allowNSFWContent, t1, t2, t3].filter(Boolean);
    $[0] = localPreferenceState.filterBot;
    $[1] = localPreferenceState.filterNew;
    $[2] = localPreferenceState.showBoards;
    $[3] = preferenceState.allowNSFWContent;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const activeFiltersCount = t4.length;
  const hasActiveFilters = localPreferenceState.selectedFactiiis.length > 0 || localPreferenceState.dataFilter.length > 0 || activeFiltersCount > 0;
  const badge = usePresence(hasActiveFilters);
  let t5;
  if ($[8] !== currentUser.isAuthenticated || $[9] !== factiiiFilterOpen || $[10] !== openAuthContinueModal || $[11] !== setFactiiiFilterOpen) {
    t5 = e => {
      e.stopPropagation();
      if (!currentUser.isAuthenticated) {
        return openAuthContinueModal();
      }
      setFactiiiFilterOpen(!factiiiFilterOpen);
    };
    $[8] = currentUser.isAuthenticated;
    $[9] = factiiiFilterOpen;
    $[10] = openAuthContinueModal;
    $[11] = setFactiiiFilterOpen;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = factiiiFilterOpen ? "Close Advanced Filters" : "Open Advanced Filters";
  const t7 = factiiiFilterOpen ? "Close Advanced Filters" : "Open Advanced Filters";
  const t8 = `absolute inset-0 transition-opacity duration-300 ${factiiiFilterOpen ? "opacity-0" : "opacity-100"}`;
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Logo height={35} bgColor="transparent" color="rgb(var(--text-secondary-color))" />;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t8) {
    t10 = <div className={t8}>{t9}</div>;
    $[14] = t8;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = `absolute inset-0 transition-opacity duration-300 ${factiiiFilterOpen ? "opacity-100" : "opacity-0"}`;
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Logo height={35} bgColor="transparent" color="rgb(var(--factiii-active-color))" />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t11) {
    t13 = <div className={t11}>{t12}</div>;
    $[17] = t11;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t10 || $[20] !== t13) {
    t14 = <div className="relative h-[35px] w-[35px]">{t10}{t13}</div>;
    $[19] = t10;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== activeFiltersCount || $[23] !== badge.exiting || $[24] !== badge.rendered) {
    t15 = badge.rendered && <div className={`absolute -right-1 -top-1 flex size-5 items-center justify-center rounded-full bg-textSecondary/40 text-[10px] font-semibold text-textPrimary [--enter-scale:0] [--exit-scale:0] ${badge.exiting ? "anim-exit" : "anim-enter"}`}>{activeFiltersCount}</div>;
    $[22] = activeFiltersCount;
    $[23] = badge.exiting;
    $[24] = badge.rendered;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15 || $[28] !== t5 || $[29] !== t6 || $[30] !== t7) {
    t16 = <button className="group relative flex items-center justify-center rounded-lg transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]" onClick={t5} title={t6} aria-label={t7}>{t14}{t15}</button>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t5;
    $[29] = t6;
    $[30] = t7;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  return t16;
};
export default FactiiiFilterButton;